import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VeeValidate, { Validator } from 'vee-validate';
// 导入共用组件
import global from './components/common/global.vue';
import zh_CN from 'vee-validate/dist/locale/zh_CN';

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import MetaInfo from 'vue-meta-info';
import BaiduMap from 'vue-baidu-map';

import 'element-ui/lib/theme-chalk/index.css';
import element from './element/index';
import ElementUI from 'element-ui';
Vue.use(element);


require('./style/reset.css');
require('./style/common.css');

Vue.use(VueAxios, axios);
Vue.use(VeeValidate);
Vue.use(MetaInfo);
Vue.use(ElementUI);
Validator.localize('zh_CN', zh_CN);

Vue.use(BaiduMap, {
    ak: 'uXRnW5KnsRHsIseRVNRrAvtnBWd2sVHR'
});

Validator.extend('isOrderNo', {
    getMessage() {
        return '请输入正确的运单号';
    },
    validate(value) {
        return /^[a-zA-Z0-9_\-,\s]+$/.test(value);
    }
});

Vue.prototype.COMMON = global;
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999
    }
});

new Vue({
    router,
    render: h => h(App),
    mounted() {
        document.dispatchEvent(new Event('vue-mounted'));
    }
}).$mount('#app');

